import React, { useState } from "react";
import classnames from "classnames";

import ImageModal from "../cropper/ImageModal";
import messages from "../../../constants/messages";

const PersonalisedLogoInput = ({
  name,
  onChange,
  showPreview,
  files,
  buttonClass,
  onError,
  onRemove,
  title,
}) => {
  const [image, setImage] = useState("");
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const handleFile = e => {
    if (e.target.files.length > 0) {
      const file = e.target.files;
      const maxAllowedSize = 5 * 1024 * 1024;
      if (file[0].size > maxAllowedSize) {
        onError(messages.MAX_FILE_SIZE);
      } else {
        setImage(file[0]);
        setModalIsOpen(true);
      }
      e.target.value = null;
    }
  };
  const handleRemove = index => {
    const newFiles = [...files];
    if (newFiles[index]?.src) {
      onRemove(newFiles[index]);
    }

    newFiles.splice(index, 1);
    onChange({ [name]: newFiles });
  };

  const onChangeHandler = file => {
    const uploadedFiles = Array.from(file);
    onChange({
      [name]: files ? [...files, ...uploadedFiles] : uploadedFiles,
    });
  };

  let inputElement;

  return (
    <>
      <ImageModal
        modalIsOpen={modalIsOpen}
        closeModal={() => {
          setModalIsOpen(prevState => !prevState);
        }}
        image={image}
        onCropImage={croppedImg => onChangeHandler([croppedImg])}
        imageAspect={1}
      />
      <div className="mt-n3">
        <input
          ref={input => (inputElement = input)}
          accept="image/png,image/jpg,image/jpeg"
          type="file"
          style={{ display: "none" }}
          onChange={handleFile}
        />
        <div className="file-upload-container mb-3">
          {showPreview && files && files.length > 0 ? (
            files.map((file, index) => (
              <div className="" key={file.name}>
                <img
                  src={file.src || URL.createObjectURL(file)}
                  style={{
                    objectFit: "contain",
                    height: 150,
                    width: 300,
                    display: "inline",
                  }}
                  alt="img"
                />
                <button
                  onClick={() => handleRemove(index)}
                  type="button"
                  className="close float-right"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            ))
          ) : (
            <button
              style={{
                border: "none",
                color: "#828282",
                width: "100%",
                height: 160,
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              className={classnames(" file-upload-btn mx-auto", buttonClass)}
              onClick={() => inputElement.click()}
            >
              <svg
                width="12"
                height="13"
                viewBox="0 0 12 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.75 10H8.25V5.5H11.25L6 0.25L0.75 5.5H3.75V10ZM0.75 11.5H11.25V13H0.75V11.5Z"
                  fill="#707070"
                />
              </svg>{" "}
              &nbsp; {title}
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default PersonalisedLogoInput;
